export default __webpack_public_path__ + "static/media/The pin.c4c4e16c.svg";